import { render, staticRenderFns } from "./Aceite.vue?vue&type=template&id=4639da40&"
import script from "./Aceite.vue?vue&type=script&lang=js&"
export * from "./Aceite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports